// extracted by mini-css-extract-plugin
export default {"fieldContainer":"customer-contract-notes-add-edit-dialog_fieldContainer__4z3ia","errorMessage":"customer-contract-notes-add-edit-dialog_errorMessage__9q5Id"};